import React, { useContext, useEffect, useMemo, useState } from 'react';
import { CONFIG } from 'config/config';
import { provincesList } from 'const/provinces';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import {
	AnalyticsWrapper,
	Button,
	NavigationWrapper,
	PickerHOC,
	Text,
	UiWrapper,
	UserWrapper,
	View,
} from '@coinscrap/webapp-core';

import { Wrapper } from 'layout/components/Body/Wrapper';
import Footer from 'layout/components/Footer/Footer';
import Header from 'layout/components/Header/Header';

import BackNextButton from 'components/BackNextButton/BackNextButton';
import InputLabel from 'components/InputLabel/InputLabel';
import LoadingScreen from 'components/LoadingScreen/LoadingScreen';
import { MainModal } from 'components/MainModal/MainModal';
import { OptionButton } from 'components/OptionButton/OptionButton';

import { useGetError } from 'hooks/useGetError';
import { useInitialScrollToTop } from 'hooks/useInitialScrollToTop';
import { useSendEmailContact } from 'hooks/useSendEmailContact';

import { MainButton } from '../../../components/MainButton/MainButton';
import { AgentContext } from '../../../contexts/agent';
import { useCoinscrapPageView } from '../../../hooks/useCoinscrapPageView';
import { Privacity } from '../../05_ClientData/components/Privacity';

export const CannotConfirm = PickerHOC(
	{
		user: {
			sourceWrapper: UserWrapper,
			sourcePath: 'user',
		},
	},
	LoadingScreen,
)(() => {
	const { agent } = useContext(AgentContext);
	const { openModal, useHeader, useFooter, useLoading } = UiWrapper.use();
	const { query, goBack } = NavigationWrapper.use();
	const { updateUser } = UserWrapper.use();
	const { regLead } = AnalyticsWrapper.use();
	const { user } = PickerHOC.use();
	const { t, i18n } = useTranslation();

	const [loading, setLoading] = useState();

	useFooter(<Footer />, []);
	useHeader(<Header />, []);
	useLoading(loading, { loadingMessage: loading });
	useInitialScrollToTop();
	useCoinscrapPageView('CannotConfirm');
	const getError = useGetError();

	// ESTADO
	const isB2B = useMemo(() => user?.metadata?.isB2B || false, [user]);
	const sendContactEmail = useSendEmailContact(user.id);

	const [showContactForm, setShowContactForm] = useState(false);

	const [prevPage, setPrevPage] = useState(query?.from || 'No detectada');

	const [emailSent, setEmailSent] = useState(false);

	const [name, setName] = useState(
		user?.name?.trim() === 'NEW_USER' ? '' : user?.name?.trim() || '',
	);

	const [email, setEmail] = useState(user?.email?.trim() || ' ');

	const [isEmailCorrect, setIsEmailCorrect] = useState(true);

	const [province, setProvince] = useState(user?.metadata?.address?.province);

	const [provinceCode, setProvinceCode] = useState(
		provincesList.find((item) => item.NAME === user?.metadata?.address?.province)?.VALUE,
	);

	const [wantsInformation, setWantsInformation] = useState(user?.metadata?.acceptsContact || '');
	const [privacityAccepted, setPrivacityAccepted] = useState(
		user?.metadata?.privacityAccepted || '',
	);

	const [advertising, setAdvertising] = useState(
		user?.metadata?.privacity?.advertising === false
			? false
			: user?.metadata?.privacity?.advertising ?? false,
	);

	const [data, setData] = useState(
		user?.metadata?.privacity?.data === false
			? false
			: user?.metadata?.privacity?.data ?? false,
	);

	const [profiling, setProfiling] = useState(
		user?.metadata?.privacity?.profiling === false
			? false
			: user?.metadata?.privacity?.profiling ?? false,
	);

	useEffect(() => {
		if (advertising === true) {
			setData(false);
			setProfiling(true);
			setWantsInformation(true);
			setPrivacityAccepted(true);
		} else {
			setData(false);
			setProfiling(false);
			setWantsInformation(false);
			setPrivacityAccepted(false);
		}
		return () => {};
	}, [advertising]);

	const [walmericDelioId, setWalmericDelioId] = useState(
		user?.metadata?.analytics?.WALMERIC_DELIO?.leadId || undefined,
	);

	const [phoneNumber, setPhoneNumber] = useState(user?.phoneNumber || null);
	const [phoneNumberFixed, setPhoneNumberFixed] = useState(undefined);
	const [isPhoneNumberFixed, setIsPhoneNumberFixed] = useState(false);

	const handleSetPhoneNumber = (telefono) => {
		// console.log('telefono', telefono);

		const codigoPais = telefono?.substring(0, 3);
		// console.log('codigoPais', codigoPais);
		const restoNumero = telefono?.substring(3);
		// console.log('restoNumero', restoNumero);
		const inicioNumero = restoNumero?.substring(0, 1);
		// console.log('inicioNumero', inicioNumero);
		if (codigoPais === '+34' && restoNumero.length > 9 && inicioNumero === '0') {
			// console.log('🟡 setPhoneNumber 1', `${restoNumero?.substring(1)}`);
			setPhoneNumber(`${restoNumero?.substring(1)}`);
			setPhoneNumberFixed(`${restoNumero?.substring(1)}`);
			return;
		}
		if (phoneNumberFixed && !isPhoneNumberFixed && telefono !== `+34${phoneNumberFixed}`) {
			// console.log('🟠 setPhoneNumber 2', `+34${phoneNumberFixed}`);
			setPhoneNumber(`+34${phoneNumberFixed}`);
			setIsPhoneNumberFixed(true);
			return;
		}
		// console.log('🔴 setPhoneNumber 3', `${telefono}`);
		setPhoneNumber(telefono);
		setPhoneNumberFixed(undefined);
		setIsPhoneNumberFixed(false);
	};

	// console.log('phoneNumber', phoneNumber);

	// NAVIGATION
	const next = async () => {
		try {
			setLoading('Guardando...');

			let leadId = undefined;
			if (agent.delioEnabled) {
				try {
					// DELIO/WALMERIC LEAD REGISTER
					if (
						!walmericDelioId ||
						(walmericDelioId && walmericDelioId?.toLowerCase()?.includes('error'))
					) {
						const nombreLead = encodeURIComponent(`${name} ${user?.surname || ''}`);
						leadId = await regLead({
							origen: agent?.delioOrigen ?? 'coinscrapfinance',
							phone: phoneNumber.slice(-9),
							email: email,
							name: nombreLead,
						});
						setWalmericDelioId(leadId);
					}
				} catch (e) {
					console.error('ERROR', e);
					leadId = e;
					setWalmericDelioId(leadId);
					setLoading(undefined);
				}

				console.log('🚀 Delio leadId →', leadId || walmericDelioId);
			}

			await updateUser({
				username: {
					...user?.username,
					name,
				},
				email,
				phoneNumber,
				metadata: {
					...user?.metadata,
					address: {
						...user?.metadata?.address,
						province,
					},
					acceptsContact: wantsInformation,
					privacityAccepted,
					privacity: {
						advertising,
						data,
						profiling,
					},
					analytics: {
						...user?.metadata?.analytics,
						WALMERIC_DELIO: agent.delioEnabled
							? {
									...user?.metadata?.analytics?.WALMERIC_DELIO,
									leadId:
										leadId && typeof leadId === 'string'
											? leadId
											: walmericDelioId,
							  }
							: undefined,
					},
				},
			});

			setLoading('Enviando...');

			const screenNames = {
				CALL: 'Solicita una llamada',
				HEADER_CONTACT: 'Solicita una llamada fuera de horario de soporte',
				SIMULATION_DETAILS: 'Detalles previos a la tarificación',
				TARIFICATION: 'Tarificación',
				PRIVACITY: 'Política de privacidad no aceptada',
				PBC: 'Preguntas de blanqueo de capitales',
				PBC_OTHER_ORIGIN: 'Preguntas de blanqueo de capitales. Other funds origin',
				SALUD: 'Preguntas de salud',
				NOTOWNER_CHARGEACCOUNT: 'Cuenta bancaria',
				DNI: 'Documento de identidad',
				DNI_FACE: 'El documento de identidad no contiene una cara en la parte frontal',
				SIGN_CONTRACT: 'Firma del contrato',
				PREEMISSION: 'Preemisión',
				PREEMISSION_BLOCKAGES: 'Preemisión blockages',
			};

			const paginaPrevia = screenNames[prevPage];
			await sendContactEmail(name, phoneNumber, email, paginaPrevia);

			setEmailSent(true);
			setLoading(undefined);

			openModal(
				() => (
					<MainModal
						type="success"
						text="Muchas gracias, te llamaremos a la mayor brevedad"
					/>
				),
				{
					disableClickAway: true,
					closeButton: true,
					modalClass: isMobile ? 'modal-xl' : 'modal-main',
					key: 'modal-CannotConfirm-OK',
				},
			);
		} catch (e) {
			setLoading(undefined);
			openModal(() => <MainModal type="error" text={getError(e)} />, {
				disableClickAway: true,
				closeButton: true,
				modalClass: isMobile ? 'modal-xl' : 'modal-main',
				key: 'modal-CannotConfirm-KO',
			});
		}
	};

	const isDisabled = () => {
		return emailSent || !name || !phoneNumber || !province || !privacityAccepted;
	};

	// EFFECTS
	useEffect(() => {
		console.log('📌 user', user);
		// if (!isB2B) {
		// 	setShowContactForm(true);
		// }
		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (query?.from) {
			setPrevPage(query?.from);
		}
		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [query?.from]);

	useEffect(() => {
		if (agent.identifier === 'rastreator') {
			setShowContactForm(true);
		}
		return () => {};
	}, [agent.identifier]);

	if (showContactForm) {
		return (
			<Wrapper
				showTopSection
				showStepBar={false}
				step={0}
				title={
					isB2B
						? t('cannotConfirm.weCallYou')
						: {
								PBC: t('cannotConfirm.weSorry'),
								SALUD: t('cannotConfirm.weSorryHealth'),
								CALL: t('landing.features.callUs.title'),
								HEADER_CONTACT: t('cannotConfirm.headerContact'),
						  }[prevPage] || '¡Lo sentimos! No es posible continuar con el proceso.'
				}
			>
				<Text headingTertiarySt isB2B>
					Rellena el formulario y un agente se pondrá en contacto contigo a la mayor
					brevedad.
				</Text>
				<View inputFreeRowSt>
					<InputLabel
						value={name}
						onChange={(e) => {
							setName(e.target.value);
						}}
						label={t('landing.features.callUs.name')}
						style={{
							marginTop: -20,
							maxWidth: isMobile ? 'none' : 300,
						}}
					/>
				</View>
				<View inputFreeRowSt>
					<InputLabel
						value={phoneNumber}
						onChange={(value) => {
							handleSetPhoneNumber(value);
						}}
						label={t('landing.features.callUs.phone')}
						type="phone"
						style={{
							marginTop: -20,
							maxWidth: isMobile ? 'none' : 300,
						}}
					/>
				</View>
				<View inputFreeRowSt>
					<InputLabel
						value={provinceCode || 0}
						onChange={(e) => {
							setProvince(
								provincesList.find((item) => item.VALUE === e.target.value)?.NAME,
							);
							setProvinceCode(e.target.value);
						}}
						label={t('landing.features.callUs.city')}
						type="select"
						selectOptions={provincesList.map((item) => {
							return {
								label: item.NAME,
								value: item.VALUE,
							};
						})}
						style={{
							marginTop: -20,
							maxWidth: isMobile ? 'none' : 300,
						}}
					/>
				</View>
				{/* {CONFIG.showMandatory && (
					<Text labelInputSt>
						{t('landing.features.callUs.mandatory')}
					</Text>
				)} */}

				<Privacity advertising={advertising} setAdvertising={setAdvertising} />

				<BackNextButton
					/* isBackShown={false} */
					onClickBack={() => {
						if (agent.identifier === 'rastreator') {
							CONFIG.routing.cannotConfirm.back(goBack);
						} else {
							setShowContactForm(false);
						}
					}}
					onClickNext={next}
					nextText={'Enviar'}
					isNextDisabled={isDisabled()}
				/>
			</Wrapper>
		);
	}
	return (
		<Wrapper
			showTopSection
			showStepBar={false}
			step={0}
			title={
				isB2B
					? t('cannotConfirm.weCallYou')
					: {
							CALL: t('landing.features.callUs.title'),
							HEADER_CONTACT: t('cannotConfirm.headerContact'),
					  }[prevPage] || '¡Lo sentimos! No es posible continuar con el proceso.'
			}
		>
			{agent.delioEnabled ? (
				<MainButton
					onClick={() => setShowContactForm(true)}
					style={{
						width: isMobile ? '100%' : '250px',
						marginBottom: 10,
					}}
				>
					Quiero que me llamen
				</MainButton>
			) : null}

			<a
				href={`tel:${agent?.delioPhone ?? CONFIG.contactPhone.value}`}
				target="_blank"
				rel="noopener noreferrer"
				style={{ width: isMobile ? '100%' : '250px', textDecoration: 'none' }}
			>
				<MainButton
					onClick={() => console.log('LLAMANDO...')}
					style={{
						width: isMobile ? '100%' : '250px',
					}}
				>
					Llamar
				</MainButton>
			</a>
		</Wrapper>
	);
});
